import { cn } from '@/app/_helper/tailwind';
import { ComponentProps } from 'react';

type OrganizationLogoProps = {
    src: string;
    alt: string;
} & ComponentProps<'div'>;
const OrganizationLogo = ({ src, alt, className }: OrganizationLogoProps) => {
    return (
        <div data-name="organization-logo" className={cn('max-w-[55px] max-h-[55px] relative', className)}>
            <img alt={alt} className='w-full object-contain' src={src} loading='lazy' />
        </div>
    );
};

export default OrganizationLogo;
